// Note: Pavement Design Type
// TODO: Parameter values are default value (need to be verified) 

const JPCPData = {
    "pccElasticModulus": { "min": 3.0, "max": 5.0, "mean": 4.0, "distribution": "Uniform" },
    "pccCompStrength": { "min": 3500, "max": 4500, "mean": 4000, "distribution": "Uniform" },
    "pccModulesOfRupture": { "min": 562, "max": 637, "mean": 600, "distribution": "Uniform" },
    "coefficientOfThermalExpansion": { "min": 4.0, "max": 6.0, "mean": 5.0, "distribution": "Uniform" },
    "jointSpacing": { "min": 15, "max": 15, "mean": 15, "distribution": "Uniform" },
    "baseResilientModulus": { "min": 20000, "max": 40000, "mean": 30000, "distribution": "Uniform" },
    "subgradeResilientModulus": { "min": 8000, "max": 20000, "mean": 14000, "distribution": "Uniform" },
    "depthToRigidFoundation": { "min": 6, "max": 10, "mean": 8, "distribution": "Uniform" },
};
const HMACData = {
    "acBinderType": { "value": 0, "distribution": "Uniform" },
    "effectiveBinderContent": { "min": 4.0, "max": 6.0, "mean": 5.0, "distribution": "Uniform" },
    "airVoids": { "min": 3.0, "max": 5.0, "mean": 4.0, "distribution": "Uniform" },
    "acElasticModulus": { "min": 200000, "max": 500000, "mean": 350000, "distribution": "Uniform" },
    "baseResilientModulus": { "min": 20000, "max": 40000, "mean": 30000, "distribution": "Uniform" },
    "subgradeResilientModulus": { "min": 8000, "max": 20000, "mean": 14000, "distribution": "Uniform" },
    "depthToRigidFoundation": { "min": 6, "max": 10, "mean": 8, "distribution": "Uniform" },
};

const PavementDesignType = {
    "id": 1,
    "design": {
        "title": "Design 1",
        "surface": { 
            "type": "JPCP",
            "thinkness": {
                "min": 200,
                "max": 200,
                "MC": []
               },
            "dowelDiameter": {
                "min": 1.0,
                "max": 1.5,
                "MC": []
               }
            },
        "base": {
            "type": "Garnular Base",
            "thinkness": {
                "min": 200,
                "max": 200,
                "MC": []
            }},
        "customThickness": false,
        'usePhaseComponent': false,
        'kValue': {
            "min": 0.0,
            "max": 0.0,
            "MC": []
        }
    },
    'experiment': { 
        "design_specification": "AASHTO1993", 
        "design_life": 10,
        "number_of_iterations": 100
    },

    "jpcpDesign": JPCPData,
    "hmaDesign": HMACData,
    "mnr": [
        {"timing_min": null, "timing_max": null, "treatment_type": "Unspecified", "material_removal": null, "material_addition": null},
        {"timing_min": null, "timing_max": null, "treatment_type": "Unspecified", "material_removal": null, "material_addition": null},
        {"timing_min": null, "timing_max": null, "treatment_type": "Unspecified", "material_removal": null, "material_addition": null},
        {"timing_min": null, "timing_max": null, "treatment_type": "Unspecified", "material_removal": null, "material_addition": null},
        {"timing_min": null, "timing_max": null, "treatment_type": "Unspecified", "material_removal": null, "material_addition": null},
        {"timing_min": null, "timing_max": null, "treatment_type": "Unspecified", "material_removal": null, "material_addition": null},
    ],
};

export default PavementDesignType;